import React from 'react';
import { Box } from '@mantine/core';

interface GameLayoutProps {
  header?: React.ReactNode;
  headerLeft?: React.ReactNode;
  headerRight?: React.ReactNode;
  content: React.ReactNode;
  controls?: React.ReactNode;
  bottomControls?: React.ReactNode;
  mode?: 'draw' | 'write';
  backgroundColor?: string;
}

export const GameLayout: React.FC<GameLayoutProps> = ({
  header,
  headerLeft,
  headerRight,
  content,
  controls,
  bottomControls,
  mode = 'draw',
  backgroundColor = '#e1f2ef'
}) => {
  // Use the same layout for all screen sizes
  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        minHeight: '100vh',
        backgroundColor: backgroundColor
      }}
    >
      {/* Header - fixed height */}
      {(header || headerLeft || headerRight) && (
        <Box
          px="md"
          pt="md"
          pb="sm"
          style={{
            flexShrink: 0,
            position: 'relative',
            backgroundColor: backgroundColor
          }}
        >
          {header}
        </Box>
      )}
      
      {/* Content - flexible middle section */}
      <Box
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'auto',
          padding: 0,
          paddingBottom: bottomControls ? '100px' : controls ? '120px' : 0,
          backgroundColor: backgroundColor
        }}
      >
        {content}
      </Box>
      
      {/* Controls - fixed at bottom */}
      {controls && (
        <Box
          p="md"
          pb="xl"
          style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            borderTop: '1px solid var(--mantine-color-gray-3)',
            backgroundColor: backgroundColor,
            display: 'flex',
            justifyContent: 'center',
            paddingBottom: 'env(safe-area-inset-bottom, 24px)',
            zIndex: 100,
            overflowX: 'auto',
            maxWidth: '100vw'
          }}
        >
          {controls}
        </Box>
      )}
      
      {/* Bottom Controls - fixed at very bottom */}
      {bottomControls && (
        <Box
          style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            padding: 'var(--mantine-spacing-md)',
            backgroundColor: backgroundColor,
            borderTop: '1px solid var(--mantine-color-gray-3)',
            zIndex: 100
          }}
        >
          {bottomControls}
        </Box>
      )}
    </Box>
  );
};